import Joi from 'joi-browser'
import moment, { duration } from 'moment'
import React, { Component } from 'react'
import Form from '../../common/form/form'
import SelectSearchAsync from '../../common/form/selectSearchAsync'
import SelectSearch from '../../common/form/selectSearch'
import Select from 'react-select'

import SubmitBtn from '../../common/form/submitBtn'
import { getPatient, patientSearch, patientSearchForStaff } from '../../../store/patient'
import Header from './header'
import LeftBar from './leftBar'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import {
  createOrderByDoctor,
  createOrderByStaff,
  getAppointment,
  loadDate,
  loadSlot,
} from '../../../store/appointment'
import { toast } from 'react-toastify'
import AlertSuccess from '../../common/alertSuccess'
import AlertError from '../../common/alertError'
import { getDoctor } from '../../../store/doctor'
import { Tooltip as ReactTooltip } from 'react-tooltip'
import dayjs from 'dayjs';
import StaffleftBar from './staffleftBar'
import { getStaffToken } from '../../services/localStorageServices'

class NewAppointment extends Form {
  state = {
    loader: false,
    btnClass: 'btn btn-primary btn-lg',
    data: {
      patient: '',
      date: '',
      time: '',
      duration: '',
      fee: '',
      type: '',
      clinicType: null,
      isGetPayment: false,
    },
    timeSlot: [],
    errors: {},
    sidebarToogle: false,
  }

  toggleSidebar = () => {
    this.setState({ sidebarToogle: !this.state.sidebarToogle })
  }

  getTimeStops = (start, end) => {
    var startTime = moment(start, 'HH:mm')
    var endTime = moment(end, 'HH:mm')

    if (endTime.isBefore(startTime)) {
      endTime.add(1, 'day')
    }

    var timeStops = []

    while (startTime <= endTime) {
      timeStops.push({
        name: new moment(startTime).format('hh:mm A'),
        value: new moment(startTime).format('HH:mm'),
      })
      startTime.add(15, 'minutes')
    }
    return timeStops
  }
  schema = {
    patient: Joi.object()
      .required()
      .error(errors => {
        errors.forEach(err => {
          switch (err.type) {
            case 'object.base':
              err.message = 'Patient Required'
              break
          }
        })
        return errors
      }),
    type: Joi.object()
      .required()
      .error(errors => {
        errors.forEach(err => {
          switch (err.type) {
            case 'object.base':
              err.message = 'Type Required'
              break
          }
        })
        return errors
      }),
    duration: Joi.object()
      .required()
      .error(errors => {
        errors.forEach(err => {
          switch (err.type) {
            case 'object.base':
              err.message = 'Duration Required'
              break
          }
        })
        return errors
      }),
    date: Joi.object()
      .required()
      .error(errors => {
        errors.forEach(err => {
          switch (err.type) {
            case 'date.base':
              err.message = 'Date required'
              break
          }
        })
        return errors
      }),

    time: Joi.object().error(errors => {
      errors.forEach(err => {
        switch (err.type) {
          case 'object.base':
            err.message = 'Time required'
            break
        }
      })
      return errors
    }),

    fee: Joi.number().error(errors => {
      errors.forEach(err => {
        switch (err.type) {
          case 'number.base':
            err.message = 'Fee required'
            break
        }
      })
      return errors
    }),

    clinicType: Joi.when('type', {
      is: Joi.object().keys({
        value: Joi.valid('clinic', 'walkin')
      }),
      then: Joi.object()
        .required()
        .error(errors => {
          errors.forEach(err => {
            switch (err.type) {
              case 'any.required':
              case 'object.base':
                err.message = 'Clinic Type required';
                break;
            }
          });
          return errors;
        }),
      otherwise: Joi.optional().allow(null, ''),
    }),

    isGetPayment: Joi.boolean(),
  }
  componentDidMount() {
    document.body.classList.remove('p-0')
    document.body.classList.add(
      this.props.history.location.pathname !== '/staff/newAppointment'
        ? 'dashboard'
        : 'dashboard-staff'
    )
    if(getStaffToken("auth")){
      this.props.patientSearchForStaff({
      sort_by: 'created_on',
      sort: 'desc',
      })    
    } else {
      this.props.patientSearch({
      sort_by: 'created_on',
      sort: 'desc',
      }) 
    }

    this.props.loadDate()
  }
  componentDidUpdate(prevProps) {
    if (prevProps.getAppointment.slots !== this.props.getAppointment.slots) {
      const timeSlot = this.props.getAppointment.slots.map(e => ({
        name: e.is_available
          ? moment(e.start).utc().format('hh:mm A')
          : moment(e.start).utc().format('hh:mm A') + ' - Not available',
        value: moment(e.start).utc().format('HH:mm'),
        isDisabled: !e.is_available,
      }))

      this.setState({ timeSlot })
    }
  }

  updateData = data => {
    this.setState({ data })
    console.log(data)
  }

  loadOptions = inputValue => {
  if(getStaffToken("auth")){
    this.props.patientSearchForStaff({
      search: inputValue,
      sort_by: 'created_on',
      sort: 'desc',
    })
  } else {
    this.props.patientSearch({
      search: inputValue,
      sort_by: 'created_on',
      sort: 'desc',
    })
  }
    console.log(inputValue)
  }
  updateStep = step => this.setState({ step })

  onChange = res => {
    const patient = res.currentTarget
    const { data, errors } = this.state
    data.patient = patient
    errors.patient = ''
    this.setState({ data, errors })
  }

  // onChangeDate = res => {
  //   const date = res.currentTarget
  //   const { data, errors } = this.state
  //   data.date = date
  //   errors.date = ''
  //   this.setState({ data, errors })
  //   // console.log("formattedDate : ",formattedDate)
  //   this.props.loadSlot(
  //     this.props.doctorProfile._id,
  //     date.value,
  //     this.state.data.type.value === 'walkin'
  //       ? 'clinic'
  //       : this.state.data.type.value
  //   )
  // } 
   onChangeDate = selectedDate => {
    // console.log("onchangeDate res ---------------> ", selectedDate)
    // const date = res.currentTarget
    const formattedDate = selectedDate.toISOString().split('T')[0]
    const { data, errors } = this.state
    data.date = selectedDate
    data.duration = ''
    if (data.time) {
      data.time = undefined;
    }
    errors.date = ''
    console.log("data ----> ", data)
    this.setState({ data, errors, timeSlot: [] })
  }

  onChangeType = res => {
    const type = res.currentTarget
    const { data, errors } = this.state
    if (type.value === 'walkin') {
      data.date = {
        name: this.props.getAppointment.dates[0].date,
        value: this.props.getAppointment.dates[0].date,
      }
      this.props.loadSlot(
        this.props.doctorProfile._id,
        this.props.getAppointment.dates[0].date,
        type.value === 'walkin' ? 'clinic' : type.value,
        this.state.data.duration.value 
      )
    }
    data.type = type
    errors.type = ''
    this.setState({ data, errors })
  }

  onChangeClinicType = selected => {
    const { data, errors } = this.state
    data.clinicType = selected
    data.date = ''
    data.duration = ''
    if (data.time) {
      data.time = undefined;
    }
    errors.clinicType = ''
    this.setState({ data, errors })
  }

  onChangeTime = res => {
    const time = res.currentTarget
    const { data, errors } = this.state
    data.time = time
    errors.time = ''
    this.setState({ data, errors })
  }

 onChangeDuration = res => {
  const duration = res.currentTarget;
  if (!this.state.data.date) {
    this.setState(prev => ({
      errors: { ...prev.errors, date: "Please select a date first." }
    }));
    return;
  }
  this.setState(prev => ({
    data: {
      ...prev.data,
      duration,
      time: prev.data.time ? undefined : '',
    },
    errors: { ...prev.errors, duration: '' }
  }), () => {
    const formattedDate = this.state.data.date.toISOString().split('T')[0];

    this.props.loadSlot(
      this.props.doctorProfile._id,
      formattedDate,
      this.state.data.type.value === 'walkin'
        ? 'clinic'
        : this.state.data.type.value,
      this.state.data.duration.value,
      this.state.data.clinicType?.value,
    )
  });
};


  doSubmit = () => {
    const { patient, date, time, fee, type, isGetPayment, duration, clinicType } = this.state.data
    const timeArr = time.value.split(':')
    const dateTime = moment(date)    
    const payload = {
      patient_id: patient.value,
      appointment_time: dateTime.format(
        'YYYY-MM-DD[T' + timeArr[0] + ':' + timeArr[1] + ':00.000Z]'
      ),
      fees: fee,
      type: type.value,
      duration: duration.value,
      isGetPayment,
    }
    if (type.value === "clinic") {
      payload.clinic_type = Number(clinicType.value)
    }
    console.log(date, payload, 'val submit')
    if (!this.state.loader) {
      this.setState({
        btnClass: 'btn btn-primary btn-lg disabled',
        loader: true,
      })
      if(getStaffToken("auth")){
      this.props.createOrderByStaff(payload, this.callBack)
      } else {
      this.props.createOrderByDoctor(payload, this.callBack)
      }
    }
  }

  callBack = res => {
    this.setState({
      btnClass: 'btn btn-primary btn-lg',
      loader: false,
    })
    if (res && res.status === 200) {
      toast(<AlertSuccess message={'Infomation saved.'} />)
      this.props.history.goBack()
    } else {
      toast(<AlertError message={'Something went wrong.'} />)
    }
  }

  getDurations = (schedule, type, clinicType) => {
    if (!schedule || !type) return [];

    if ((type === 'clinic' || type === 'walkin') && !clinicType) {
      return [];
    }

    const result = [];

    const getFee = (isSlot2 = false) => {
      if (type === 'online') {
        return isSlot2 ? schedule.onlineFeeSlot2 : schedule.onlineFee;
      }

      if (clinicType === 2) {
        return isSlot2 ? schedule.clinic2FeeSlot2 : schedule.clinic2Fee;
      } 

      if (clinicType === 1) {
        return isSlot2 ? schedule.clinicFeeSlot2 : schedule.clinicFee;
      }
    }

    if (schedule.time && getFee(false)) {
      result.push(schedule.time);
    }

    if (schedule.time2 && getFee(true)) {
      result.push(schedule.time2);
    }

    return result;
  };

  customStyles = {
    indicatorSeparator: styles => ({ display: 'none' }),
    option: (provided, state) => ({
      ...provided,
      '&:hover': {
        backgroundColor: 'rgb(95, 50, 187, 10%)',
        color: '#621ac0',
      },

      'color': state.isSelected ? '#621ac0' : 'black',
      'backgroundColor': state.isSelected
        ? 'rgb(95, 50, 187, 10%)'
        : provided.backgroundColor,
    }),
    control: (base, state) => ({
      ...base,
      'height': 55,
      'minHeight': 55,
      'borderColor': state.isFocused ? '#6119c0' : '#e0e0e0',
      'boxShadow': '0 !important',
      '&:hover': {
        borderColor: '#6119c0',
      },
      '&:focus': {
        borderColor: '#6119c0',
      },
    }),
    multiValueRemove: (base, state) => ({
      ...base,
      '&:hover': {
        backgroundColor: 'rgb(95, 50, 187, 10%)',
        color: '#6119c0',
      },
    }),
  }

  render() {
    const times = this.getTimeStops('00:00', '23:45')
    const doctor = this.props.doctorProfile
    const patients = this.props.patients
    const options = patients.map(e => ({
      value: e._id,
      name: (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          {e.type === 2 ? (
            <i className="fa-duotone fa-users-rectangle fa-lg" style={{ "--fa-primary-color": "#fad448", "--fa-secondary-color": "#3c83a9", "--fa-secondary-opacity": 0.8 }}></i>
          ) : e.type === 1 ? (
            <i className="fa-duotone fa-square-user fa-xl" style={{ "--fa-primary-color": "#fad448", "--fa-secondary-color": "#3c83a9", "--fa-secondary-opacity": 0.8 }}></i>
          ) : null}
          <span>{`${e.first_name} ${e.last_name} (${e.mobileCode || ''} ${e.mobile})`}</span>
        </div>
      )
    }));
    const clinicOptions = [
      doctor?.clinic_details?.name && {
        name: `${doctor.clinic_details.name} (Clinic 1)`,
        value: 1,
      },
      doctor?.clinic_details_2?.name && {
        name: `${doctor.clinic_details_2.name} (Clinic 2)`,
        value: 2,
      }
    ].filter(Boolean);

    const durations = this.getDurations(
      doctor?.schedules,
      this.state.data.type?.value,
      this.state.data.clinicType?.value
    );

    return (
      <div className={this.state.sidebarToogle ? 'dashboard on' : 'dashboard'}>
        {/* {this.props.history.location.pathname !== '/staff/newAppointment' && (
          <LeftBar />
        )} */}
        {this.props.history.location.pathname !== '/staff/newAppointment' ?
          <LeftBar /> : <StaffleftBar/>
        }
        <Header
          sidebarToogle={this.state.sidebarToogle}
          toggleSidebar={this.toggleSidebar}
        />
        <div className='dashboard-main-container'>
          <div className='dashboard-content-box'>
            <div className='d-flex align-items-start'>
              <h4>
                New Appointment
                <span className='ml-2' style={{ fontSize: '14px' }}>
                  (Only for your existing patients. You can add new patient from
                  dashboard)
                </span>
              </h4>
            </div>
            <form onSubmit={this.handleSubmit}>
              <div className='dc-body d-flex flex-wrap align-items-lg-center'>
                <div className='dc-left'>
                  <h4 className='d-block d-xl-none'>Personal Details</h4>
                  <div className='dc-form-box'>
                    <div className='row'>
                      <div className='col-md-12'>
                        <SelectSearchAsync
                          name='patient'
                          options={options}
                          label='Patient'
                          error={this.state.errors.patient}
                          value={this.state.data.patient}
                          onChange={this.onChange}
                          loadOptions={this.loadOptions}
                        />
                      </div>
                    </div>

                    {this.state.data.patient && (
                      <>
                        <div className='row'>
                          <div className='col-md-6'>
                            <SelectSearch
                              name='Type'
                              options={[
                                { name: 'online', value: 'online' },
                                { name: 'clinic', value: 'clinic' },
                                { name: 'walk-in', value: 'walkin' },
                              ]}
                              label='Type'
                              error={this.state.errors.type}
                              value={this.state.data.type}
                              onChange={this.onChangeType}
                            />
                          </div>{' '}
                          <div className="col-md-6">
                            <Select
                              styles={this.customStyles}
                              placeholder="Select Clinic"
                              options={clinicOptions.map(c => ({
                                label: c.name,
                                value: c.value,
                              }))}
                              value={this.state.data.clinicType}
                              isDisabled={
                                this.state.data.type?.value !== 'clinic' &&
                                this.state.data.type?.value !== 'walkin'
                              }
                              onChange={this.onChangeClinicType}
                            />
                          </div>
                        </div>
                        <div className='row'>
                          <div className='col-md-6'>
                            {this.renderDateInput('date', 'Appointment Date', null, null, false, this.onChangeDate, dayjs())}
                          </div> 
                          <div className='col-md-6'>
                            <SelectSearch
                              key={this.state.data.date}
                              name='duration'
                                options={durations.map(duration => ({
                                  name: `${duration} Mins`,
                                  value: duration
                                }))}
                              label='Duration'
                              error={this.state.errors.time}
                              value={this.state.data.duration}
                              onChange={this.onChangeDuration}
                            />
                          </div>
                        </div>
                        <div className='row'>
                          <div className='col-md-6'>
                            <SelectSearch
                              // key={`${this.state.data.date}-${this.state.data.duration}-${this.state.data.time}`}
                              name='time'
                              options={this.state.timeSlot}
                              label='Time'
                              error={this.state.errors.time}
                              value={this.state.data.time}
                              defaultValue={undefined}
                              onChange={this.onChangeTime}
                            />
                          </div>
                          <div className='col-md-6'>
                            {this.renderInput('fee', 'Fees', 'number')}  
                          </div>
                        </div>
                        {this.state.data.type?.value === 'online' &&
                          <div className='row'>
                            <div className='col-md-6'>
                              <div class='form-check form-check-inline'>
                                <input
                                  type='checkbox'
                                  checked={this.state.isGetPayment}
                                  id={1}
                                  class='form-check-input'
                                  name='isGetPayment'
                                  onChange={e =>
                                    this.setState({
                                      data: {
                                        ...this.state.data,
                                        isGetPayment: e.target.checked,
                                      },
                                    })
                                  }
                                />
                                <label class='form-check-label ml-4' htmlFor={1}>
                                  Get Payment
                                </label>
                              </div>
                            </div>
                          </div>
                        }
                      </>
                    )}
                  </div>
                </div>
              </div>

              <div className='prescription-btn d-flex justify-content-between align-items-center'>
                <a
                  class='btn btn-outline no-shadow'
                  onClick={() => this.props.history.goBack()}>
                  Back
                </a>
                <SubmitBtn
                  label='Save'
                  loading={this.state.loading}
                  btnClass={this.state.btnClass}
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  patientSearch: param => dispatch(patientSearch(param)),
  patientSearchForStaff: param => dispatch(patientSearchForStaff(param)),
  loadDate: () => dispatch(loadDate()),
  createOrderByDoctor: (param, callback) =>
    dispatch(createOrderByDoctor(param, callback)),
  createOrderByStaff: (param, callback) =>
    dispatch(createOrderByStaff(param, callback)),
  loadSlot: (drId, date, type, duration, clinic) => dispatch(loadSlot(drId, date, type, duration, clinic)),
})
const mapStateToProps = state => ({
  patients: getPatient(state).patientList,
  doctorProfile: getDoctor(state).profile,
  getAppointment: getAppointment(state),
})
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(NewAppointment)
)
